import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { createContext } from '../../../utils/react-helpers.esm.js';

var _createContext = createContext({
    strict: false,
    name: 'DrawerContext'
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  DrawerContextProvider = _createContext2[0],
  useDrawerContext = _createContext2[1];

export { DrawerContextProvider, useDrawerContext };
//# sourceMappingURL=drawer-context.esm.js.map
